import React, {createContext, useState} from 'react';

export const WorkflowStepsContext = createContext({
  disabledSteps: [],
  setDisabledSteps:() => ({}),
});

const WorkflowStepsProvider = ({ children }) => {
  const [disabledSteps, setDisabledSteps] = useState([]);


  return (
    <WorkflowStepsContext.Provider
      value={{
        disabledSteps,
        setDisabledSteps,
      }}
    >
      {children}
    </WorkflowStepsContext.Provider>
  );
};

export default WorkflowStepsProvider;
